module.exports = __webpack_public_path__ + "56b49ea175b36da48764eb797ac14f31.png";